export function removeParameter(url, parameterName) {
    return url.replace(new RegExp(parameterName + "=\\w+"),"")
              .replace("?&","?")
              .replace("&&","&")
              .replace(/\?+$/, '')
              .replace(/&+$/, '');
}

export function addParameters(url, parameters) {
    console.log('EEE', parameters);
    let parts = url.split('?');

    let search = new URLSearchParams(parts[1] ?? '');

    console.log(parameters);
    parameters.forEach(function(parameter) {
        search.append(parameter[0], parameter[1]);
    });

    return parts[0] + '?' + search;
}

export function stringifyParameters(parameters) {
    return Object.keys(parameters).map(function(k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(parameters[k] !== null ? parameters[k] : '')
    }).join('&');
}
